import React, { FC, PropsWithChildren, memo } from 'react';

import Typography from '@mui/material/Typography';

import useStyles from './styles.module';

interface Props extends PropsWithChildren {
  title: string;
  startTokenSymbol: string;
  endTokenSymbol: string;
}

const CounterBox: FC<Props> = ({
  title,
  children,
  startTokenSymbol,
  endTokenSymbol,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.box}>
      <Typography variant="body2" color={(theme) => theme.secondary.s3}>
        {title}
      </Typography>
      {children}
      <Typography variant="body2" color={(theme) => theme.secondary.s3}>
        {startTokenSymbol} per {endTokenSymbol}
      </Typography>
    </div>
  );
};

export default memo(CounterBox);
